// router.js
import { Outlet } from "react-router-dom";
import * as routes from "../data/links/routes";
import { usersWorkoutAccess } from "../api/workouts";
import { createBrowserRouter, redirect } from "react-router-dom";

// Providers & Layouts
import AdminRoute from "./AdminRoute";
import SetUpRoute from "./SetUpRoute";
import LoggedRoute from "./LoggedRoute";
import PrivateRoute from "./PrivateRoute";
import { AuthProvider } from "../context/AuthContext";
import FormLayout from "../components/Layouts/FormLayout";
import LoggedLayout from "../components/Layouts/Loggedlayout";
import { GoogleReCaptchaProvider } from "@google-recaptcha/react";
import { DrawerProvider } from "../context/DrawerContext";

// Pages
import Intro from "../pages/Intro";
import Admin from "../pages/Admin";
import Login from "../pages/Login";
import Terms from "../pages/Terms";
import Index from "../pages/Index";
import Donate from "../pages/Donate";
import Profile from "../pages/Profile";
import Scaling from "../pages/Scaling";
import Dashboard from "../pages/Dashboard";
import Generator from "../pages/Generator";
import ErrorPage from "../pages/ErrorPage";
import Policy from "../pages/PrivacyPolicy";
import Statistics from "../pages/Statistics";
import ShowWorkout from "../pages/ShowWorkout";
import Performance from "../pages/Performance";
import VerifyEmail from "../pages/VerifyEmail";
import UserWorkouts from "../pages/UserWorkouts";
import CreateWorkout from "../pages/CreateWorkout";
import ChangePassword from "../pages/ChangePassword";
import DeleteAccount from "../pages/DeleteAccount";
import ForgotPassword from "../pages/ForgotPassword";
import PublicWorkouts from "../pages/PublicWorkouts";
import Challenges from "../pages/Challenges";
import DeleteAccountInfo from "../pages/DeleteAccountInfo";

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <AuthProvider>
        <DrawerProvider>
          <RootRouter />
        </DrawerProvider>
      </AuthProvider>
    ),
    children: [
      {
        element: <PrivateRoute />,
        children: [
          { element: <Intro />, path: routes.INTRO },
          {
            element: <SetUpRoute />,
            children: [
              {
                element: <LoggedLayout />,
                children: [
                  {
                    element: <AdminRoute />,
                    children: [{ element: <Admin />, path: routes.ADMIN }],
                  },
                  { element: <Dashboard />, path: routes.DASHBOARD },
                  { element: <Challenges />, path: routes.CHALLENGES },
                  { element: <UserWorkouts />, path: routes.USER_WORKOUTS },
                  { element: <PublicWorkouts />, path: routes.PUBLIC_WORKOUTS },
                  { element: <Performance />, path: routes.PERFORMANCE },
                  {
                    element: <ShowWorkout />,
                    path: routes.SHOW_WORKOUT + ":wodId",
                    loader: async ({ params }) => {
                      const data = await usersWorkoutAccess({
                        wodId: params.wodId,
                      });
                      if (!data) throw redirect(routes.USER_WORKOUTS);
                      return null;
                    },
                  },
                  { element: <Profile />, path: routes.PROFILE },
                  { element: <CreateWorkout />, path: routes.CREATE_WORKOUT },
                  { element: <Generator />, path: routes.GENERATOR },
                  { element: <Statistics />, path: routes.STATISTICS },
                ],
              },
            ],
          },
        ],
      },
      {
        element: (
          <GoogleReCaptchaProvider
            type="v3"
            siteKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
          >
            <LoggedRoute />
          </GoogleReCaptchaProvider>
        ),
        children: [
          {
            element: <FormLayout />,
            children: [
              {
                element: <Login />,
                path: routes.LOGIN,
              },
              { element: <VerifyEmail />, path: routes.VERIFY_EMAIL },
              { element: <ChangePassword />, path: routes.PASSWORD_RESET },
              { element: <ForgotPassword />, path: routes.PASSWORD_RECOVER },
            ],
          },
        ],
      },

      { element: <Donate />, path: routes.DONATE },
      { element: <DeleteAccount />, path: routes.DELETE_ACCOUNT },
      { element: <DeleteAccountInfo />, path: routes.DELETE_INFO },
      { element: <Index />, path: routes.INDEX },
      {
        element: <LoggedLayout />,
        children: [
          { element: <Policy />, path: routes.POLICY },
          { element: <Terms />, path: routes.TERMS },
          { element: <Scaling />, path: routes.SCALING },
        ],
      },
      { element: <ErrorPage />, path: routes.ERROR },
    ],
  },
]);

// A simple root wrapper — ensures all routes render inside AuthProvider
function RootRouter() {
  return <Outlet />;
}

export default router;
